<template>
  <div class="auctionNoticePreview">
    <h2 class="intro-y text-lg font-medium mt-10">一键转至360pai进行租赁权拍卖</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
          class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"
      >
        <button class="button text-white bg-theme-1 shadow-md mr-2"
                @click='$router.push({path:"/assetManagement/assetDetail",query:{ assetId :  assetId}})'>
          返回
        </button>
      </div>
    </div>
    <div class="intro-y box py-10 sm:py-20 mt-5">
      <div
          class="wizard flex flex-col lg:flex-row justify-center px-5 sm:px-20"
      >
        <div
            class="intro-x lg:text-center flex items-center lg:block flex-1 z-10"
        >
          <button class="w-10 h-10 rounded-full button text-white bg-theme-1">
            1
          </button>
          <div class="lg:w-32 font-medium text-base lg:mt-3 ml-3 lg:mx-auto">
            生成招商公告
          </div>
        </div>

        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1"
          >
            2
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            填写拍卖信息
          </div>
        </div>
        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1"
          >
            3
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            完成
          </div>
        </div>
        <div
            class="wizard__line hidden lg:block w-1/2 bg-gray-200 dark:bg-dark-1 absolute mt-5"
        ></div>
      </div>
      <div class="main">
        <h3>预览招租公告</h3>
        <div class='editor'>
          <vueQuillEditor :prog='prog' @editResult='editResult'/>
        </div>
        <div style='text-align:center;margin-top: 30px;'>
          <el-button type="primary" size='large' @click='handleSubmit' :loading='loading'>
            自动生成招商公告并下载
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vueQuillEditor from "../../../../components/vueQuillEditor";
  import {createA} from "../../../../assets/js/tools";
  import {mapState} from 'vuex'
  import {getAuctionTemplate,saveAuctionTemplate} from "../../../../api/asset";

  export default {
    name: "auctionNoticePreview",
    components: {
      vueQuillEditor,
    },
    data() {
      return {
        prog:'',
        loading:false,
      }
    },
    methods: {
      init(){
        let para = {
          assetId:this.assetId
        }
        this.loading=true
        getAuctionTemplate(para).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.prog=data.content
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading=false
        })
      },
      editResult(prog){
        this.prog=prog||''
      },
      handleSubmit(){
        let para = {
          assetId:this.assetId,
          templateInfo:this.prog,
        }
        this.loading=true
        saveAuctionTemplate(para).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.$message.success('生成成功')
            createA(data.content)
            this.$router.push({path: '/assetManagement/auctionInfo' })
          } else {
            this.$message.error(data.desc)
          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading=false
        })

      },
    },
    created() {
    },
    mounted() {
      this.$nextTick(function () {
        this.init()
      })
    },
    computed: {
      ...mapState({
        assetId:state=>state.auction.form.assetId
      })
    },
  }
</script>
<style>
  .auctionNoticePreview .edui-editor,
  .auctionNoticePreview #edui1_iframeholder{
    width: 100%!important;
  }
  .auctionNoticePreview #edui1_toolbarbox{
    position: initial!important;
  }
</style>
<style scoped lang="scss">
  .auctionNoticePreview {
    .main {
      margin: 24px 16px;
      padding: 24px 45px;
      background: #fff;
      flex: auto;
      box-sizing: border-box;
    }
    h3{
      font-size: 30px;
      font-weight: 700;
      margin: 20px 0;
      text-align: center;
    }
    .editor{
      position: relative;
    }
  }
</style>
